<template>
<div class="chapter">
<div class="inner_page">
<div class="body"><div class="chapter"><a id="page_1"></a><a id="p9000f1609970001001">
</a><p class="halftitle">SEW MANY BAGS SEW LITTLE TIME</p><a id="page_2"></a><a id="p9000f1609960002001">
</a><div class="media-group"><img alt="" src="images/p9000f160g2001.png" width="87.84029%"/></div></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?6aac84e4